import React, { useEffect } from "react";
import {
  Grid,
  Box,
  Typography,
  Divider,
  Card,
  CardContent,
  Badge,
} from "@mui/material";
import { Link, useParams } from "react-router-dom";
import EmptyResult from "components/Shared/Lottie/EmptyResult";
import { ApartmentOutlined, LocationCity } from "@mui/icons-material";
import { useLazyGetDistrictByRegionIdQuery } from "store/services/LocationsApi/regionApi";

const DistrictCard = ({ districts = [] }) => {
  const validDistricts = districts.filter(
    (district) => district?._id && district?.name
  );

  return (
    <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
      {validDistricts?.length > 0 ? (
        validDistricts?.map((district) => (
          <div key={district?._id} className="group">
            <Link to={`/app/crm/district/${district?._id}/detail`}>
              <Card
                className="h-full transition-transform duration-300 hover:-translate-y-1 hover:shadow-xl"
                sx={{
                  borderRadius: 2,
                  "&:hover": {
                    boxShadow:
                      "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
                  },
                }}
              >
                <CardContent sx={{ padding: 2 }}>
                  <div className="flex items-center gap-3">
                    <div className="rounded-full bg-blue-100 p-2 transition-colors group-hover:bg-blue-200">
                      <ApartmentOutlined
                        sx={{
                          fontSize: 20,
                          color: "primary.main",
                        }}
                      />
                    </div>
                    <Typography
                      variant="body2"
                      className="line-clamp-2 font-medium"
                    >
                      {district.name}
                    </Typography>
                  </div>
                </CardContent>
              </Card>
            </Link>
          </div>
        ))
      ) : (
        <EmptyResult height={150} />
      )}
    </div>
  );
};

const DistrictTab = () => {
  const { id: regionId } = useParams();
  const [
    fetchDistrict,
    {
      data: districtRes = [],
    },
  ] = useLazyGetDistrictByRegionIdQuery();

  useEffect(() => {
    if (regionId) {
      fetchDistrict(regionId);
    }
  }, [fetchDistrict, regionId]);

  return (
    <Grid item xs={12}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        p={3}
      >
        <Box display="inline-flex" alignItems="center" gap={1.5}>
          <Badge badgeContent={districtRes?.data?.length} color="primary">
            <LocationCity style={{ color: "gray" }} />
          </Badge>

          <Typography style={{ fontWeight: 500 }}>Districts</Typography>
        </Box>
      </Box>

      <Divider />
      <Box p={2}>
        {districtRes?.data?.length > 0 ? (
          <DistrictCard districts={districtRes?.data} />
        ) : (
          <EmptyResult height={150} />
        )}
      </Box>
    </Grid>
  );
};

export default DistrictTab;
